<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="Add Order"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="rules"
                label-width="120px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-col :span="24">
                            <el-form-item
                                label="Platform"
                                prop="platform_id"
                                size="small"
                            >
                                <el-select
                                    v-model="addForm.platform_id"
                                    placeholder="Please Select"
                                    @change="shopSelect"
                                    style="width:100%"
                                >
                                    <el-option
                                        v-for="item in platformList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Order Sn"
                                prop="plt_order_sn"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.plt_order_sn"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Express"
                                prop="express_name"
                                size="small"
                            >
                                <el-select
                                    v-model="addForm.express_name"
                                    placeholder="Please Select"
                                    style="width:100%"
                                >
                                    <el-option
                                        v-for="item in expressList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Payment Code"
                                prop="pay_code"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.pay_code"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Order Amount"
                                prop="order_amount"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.order_amount"
                                    placeholder="Please input "
                                >
                                    <template slot="append">{{
                                        addForm.currency || "USD"
                                    }}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Discount"
                                prop="discount"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.discount"
                                    placeholder="Please input "
                                >
                                    <template slot="append">{{
                                        addForm.currency || "USD"
                                    }}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col :span="12">
                        <el-col :span="24">
                            <el-form-item
                                label="Store"
                                prop="shop_id"
                                size="small"
                            >
                                <el-select
                                    v-model="addForm.shop_id"
                                    placeholder="Please Select"
                                    filterable
                                    style="width:100%"
                                >
                                    <el-option
                                        v-for="item in storeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Tracking Number"
                                prop="tracking_number"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.tracking_number"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Payment Time"
                                prop="payment_time"
                                size="small"
                            >
                                <el-date-picker
                                    v-model="addForm.payment_time"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    placeholder="Please Select"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Need Tag"
                                prop="need_tag"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.need_tag"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Currency"
                                prop="currency"
                                size="small"
                            >
                                <el-select
                                    v-model="addForm.currency"
                                    placeholder="Please Select"
                                    style="width:100%"
                                >
                                    <el-option
                                        v-for="item in currencyList"
                                        :key="item.id"
                                        :label="item.code"
                                        :value="item.code"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Ship Cost"
                                prop="total_ship_cost"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.total_ship_cost"
                                    placeholder="Please input "
                                >
                                    <template slot="append">{{
                                        addForm.currency || "USD"
                                    }}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Remark" prop="remark" size="small" style="">
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.remark"
                                placeholder="Please input "
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                                style="width:91%"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-col :span="24">
                            <el-form-item
                                label="Name"
                                prop="orders_address.buyer_name"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.orders_address.buyer_name"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="State/Province"
                                prop="orders_address.state"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.orders_address.state"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Street 1"
                                prop="orders_address.street1"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.orders_address.street1"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Phone Number"
                                prop="orders_address.phone"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.orders_address.phone"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col :span="12">
                        <el-col :span="24">
                            <el-form-item
                                label="Country"
                                prop="orders_address.country"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.orders_address.country"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="City"
                                prop="orders_address.city"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.orders_address.city"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Street 2"
                                prop="orders_address.street2"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.orders_address.street2"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Postal Code"
                                prop="orders_address.postal_code"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.orders_address.postal_code"
                                    placeholder="Please input "
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="table">
                            <el-table
                                border
                                :data="addForm.orders_goods"
                                ref="attributes"
                                highlight-current-row
                                max-height="500px"
                            >
                                <el-table-column
                                    label="SKU"
                                    align="center"
                                    width="200"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'orders_goods.' +
                                                scope.$index +
                                                '.sku'
                                            "
                                        >
                                            <el-input
                                                clearable
                                                placeholder="SKU"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.sku"
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="QTY"
                                    align="center"
                                    prop="goods_num"
                                >
                                    <template slot-scope="scope">
                                        <el-input-number
                                            v-model="scope.row.goods_num"
                                            :min="1"
                                            size="small"
                                        ></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Price"
                                    align="center"
                                    prop="goods_price"
                                    width="140"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Price"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.goods_price"
                                        >
                                            <template slot="prepend"
                                                >$</template
                                            >
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Discount"
                                    align="center"
                                    prop="goods_discount"
                                    width="140"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Discount"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.goods_discount"
                                        >
                                            <template slot="prepend"
                                                >$</template
                                            >
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Metafileds"
                                    align="center"
                                    prop="custom_properties"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            readonly
                                            placeholder="Metafileds"
                                            size="small"
                                            v-model="
                                                scope.row.custom_properties
                                            "
                                            @click.native="
                                                metafiledsShowDialog(
                                                    scope.$index
                                                )
                                            "
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    :key="item"
                                    width="130"
                                >
                                    <template slot="header" slot-scope="scope">
                                        Operation
                                        <el-button
                                            type="text"
                                            icon="el-icon-plus"
                                            @click="addItem(scope)"
                                        ></el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            @click="removeItem(scope)"
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="closeDialog">Close</el-button>
        </span>
        <metafileds
            :metafiledsVisible.sync="metafiledsVisible"
            @saveMetafiled="saveMetafiled"
            :metafiledsLabel="metafiledsLabel"
        ></metafileds>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import metafileds from "./metafileds";
import { mapState, mapActions } from "vuex";
const selectPlaceholder = "Please select ";
const inputPlaceholder = "Please input ";
export default {
    computed: {
        ...mapState({
            menu_id: (state) => state.menu.menu_id,
        }),
    },
    components: {
        metafileds,
    },
    data() {
        return {
            addForm: {
                platform_id: null,
                plt_order_sn: "",
                express_name: null,
                pay_code: "",
                order_amount: "",
                discount: "",
                shop_id: null,
                tracking_number: "",
                payment_time: "",
                need_tag: "",
                currency: null,
                ship_cost: "",
                remark: "",
                country: "",
                plt_create_time: this.$moment().format("YYYY-MM-DD hh:mm:ss"),
                total_ship_cost: "",
                orders_address: {
                    buyer_name: "",
                    state: "",
                    street1: "",
                    phone: "",
                    country: "",
                    city: "",
                    street2: "",
                    postal_code: "",
                },
                orders_goods: [
                    {
                        sku: "", //sku *
                        goods_num: "", //数量 *
                        goods_price: "", //单价 *
                        goods_discount: "", //折扣
                        custom_properties: "",
                    },
                ],
            },
            rules: {
                platform_id: [
                    {
                        required: true,
                        message: selectPlaceholder,
                    },
                ],
                plt_order_sn: [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
                order_amount: [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
                order_amount: [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
                shop_id: [
                    {
                        required: true,
                        message: selectPlaceholder,
                    },
                ],
                payment_time: [
                    {
                        required: true,
                        message: selectPlaceholder,
                    },
                ],
                currency: [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
                "orders_address.buyer_name": [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
                "orders_address.street1": [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
                "orders_address.country": [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
                "orders_address.city": [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
                "orders_address.postal_code": [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ],
            },
            platformList: [],
            storeList: [],
            expressList: [],
            currencyList: [],
            emptyTableItem: {
                sku: "", //sku *
                goods_num: "", //数量 *
                goods_price: "", //单价 *
                goods_discount: "", //折扣
                custom_properties: "",
            },
            metafiledsVisible: false,
            metafiledsLabel: "",
            tableItemIndex: "",
        };
    },
    methods: {
        ...mapActions(["getExpressSelect"]),
        platformSelect() {
            cmofferApi.platformSelect({}, "get").then((res) => {
                if (res) {
                    this.platformList = res.data;
                }
            });
        },
        shopSelect() {
            cmofferApi
                .shopSelect({ platform_id: this.addForm.platform_id }, "get")
                .then((res) => {
                    if (res) {
                        this.storeList = res.data;
                    }
                });
        },
        currencySelect() {
            cmofferApi.currencySelect({}, "get").then((res) => {
                if (res) {
                    this.currencyList = res.data;
                }
            });
        },
        getEntityInfo() {
            cmofferApi.entityInfo({}, "get").then((res) => {
                if (res) {
                    console.log(res);
                    this.addForm.country = this.addForm.orders_address.country =
                        res.data.country;
                }
            });
        },
        closeDialog() {
            this.addForm.orders_goods = [
                {
                    sku: "", //sku *
                    goods_num: "", //数量 *
                    goods_price: "", //单价 *
                    goods_discount: "", //折扣
                    custom_properties: "",
                },
            ];
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },

        addItem(row) {
            this.emptyTableItem = {
                sku: "", //sku *
                goods_num: "", //数量 *
                goods_price: "", //单价 *
                goods_discount: "", //折扣
                custom_properties: "",
            };
            let dataTemplate = JSON.parse(JSON.stringify(this.emptyTableItem));
            if (this.addForm.orders_goods.length == 0 || row) {
                this.addForm.orders_goods.push(dataTemplate);
            }
        },

        removeItem(scope) {
            if (this.addForm.orders_goods.length > 1) {
                for (let i in this.addForm.orders_goods) {
                    if (i == scope.$index) {
                        this.addForm.orders_goods.splice(i, 1);
                    }
                }
            } else {
                return false;
            }
        },
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .orders(
                            {
                                ...this.addForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            this.$message.success(
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            );
                            this.closeDialog();
                            this.$parent[this.funcName]();
                        });
                }
            });
        },
        metafiledsShowDialog(i) {
            this.metafiledsVisible = true;
            this.tableItemIndex = i;
            this.metafiledsLabel =
                this.addForm.orders_goods[i].custom_properties;
        },
        saveMetafiled(data) {
            console.log("data: ", data);
            this.$set(
                this.addForm.orders_goods[this.tableItemIndex],
                "custom_properties",
                data.custom_properties
            );
        },
    },
    props: {
        addVisible: Boolean,
        funcName: String,
    },
    watch: {
        addVisible() {
            if (this.addVisible) {
                this.platformSelect();
                this.shopSelect();
                this.currencySelect();
                // this.getEntityInfo();
                this.getExpressSelect().then((res) => {
                    this.expressList = res.data;
                });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.add {
    .container {
        ::v-deep .table {
            .el-form-item {
                margin-bottom: 0px;
            }
            .el-input-group__prepend {
                padding: 0 10px;
                /* & + .el-input__inner {
                    padding-right: 10px;
                } */
            }
            .el-form-item__content{
                margin-left:139px
            }
        }
    }
}
</style>